var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.screenType === 'desktop')?_c('notifications-desktop'):_c('notifications-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }